import React from "react";
import Layout from "../components/layout";
import BlogRoll from "../components/BlogRoll"
import Head from "../components/head";



export default () => (
    <Layout>
        <Head title="tous les tutos cloud" />
        <h1>Tutos cloud</h1>
          <section>
            <div className="content">
              <BlogRoll categorie={"cloud"} />
            </div>
          </section>
    </Layout>
)